module.exports = __webpack_public_path__ + "static/media/arrow.4921ae3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/arrow.svg
// module id = 609
// module chunks = 0